var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:_vm.padding ? 'px-5' : '',attrs:{"justify":"center"}},[_c('v-img',{attrs:{"src":_vm.imageSrc,"max-width":_vm.maxWidth,"eager":_vm.eager},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }